import { render } from "./MshelBlocksAndMachineries.vue?vue&type=template&id=6190e77a&scoped=true"
import script from "./MshelBlocksAndMachineries.vue?vue&type=script&lang=js"
export * from "./MshelBlocksAndMachineries.vue?vue&type=script&lang=js"

import "./MshelBlocksAndMachineries.vue?vue&type=style&index=0&id=6190e77a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6190e77a"]])

export default __exports__